// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"267":"f99d0f5b53b1d208e66f","926":"90c63f89bf5aaf79313b"}[chunkId] + ".chunk.js";
};